import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function unicodeValidator(): ValidatorFn {
    return (control:AbstractControl) : ValidationErrors | null => {

        const value = control.value;
        const regex =/^[\x20-\x7E\u00C0-\u00FF\u0152\u0153\u0178]*$/u;
        const allowedUnicode = regex.test(value); 

        return !allowedUnicode ? { 'noUnicodeAllowed': { value: control.value } } : null;
    }
}